import BaseIconButton from './BaseIconButton';

export default BaseIconButton;
